import { checkNotEmpty, greaterThan, validDate } from './operators.js';

interface IsRequiredArg {
  value: unknown;
  help?: string;
}

interface IsGreaterThanArg {
  value: number;
  help?: string;
  comparator?: number;
}

interface IsValidDateArg {
  value: string;
  help?: string;
  format?: string;
}

export const isRequired = ({ value, help = 'Field is Required' }: IsRequiredArg) => ({
  payload: help,
  error: checkNotEmpty(value),
});

export const isGreaterThan = ({ value, help, comparator = 0 }: IsGreaterThanArg) => {
  const helpMessage = help ?? `Max value ${comparator}`;
  return {
    payload: helpMessage,
    error: greaterThan(value, comparator),
  };
};

export const isValidDate = ({ value, help, format = 'MM/DD/AAA' }: IsValidDateArg) => {
  const helpMessage = help ?? `Valid Date is required ${format}`;
  return {
    payload: helpMessage,
    error: !validDate(value),
  };
};
